import React, {createContext,useReducer} from "react";
import AuthState from "./InitialStates/AuthStates";
import Auth from "./Reducers/Auth";
import Assessment from "./Reducers/Assessments";
import AssessmentStates from "./InitialStates/AssessmentStates";
import Inspections from "./Reducers/Inspections";
import InspectionStates from "./InitialStates/InspectionStates";
import ChecklistManagerStates from "./InitialStates/ChecklistManagerStates";
import ChecklistManager from "./Reducers/ChecklistManager";
import Invoices from "./Reducers/Invoices.js";
import InvoiceStates from "./InitialStates/InvoiceStates";

export const GlobalStore = createContext({});

const StateStores = ({children}) => {
    const [authState,authDispatch] = useReducer(Auth,AuthState);
    const [AssessmentState,AssessmentDispatch] = useReducer(Assessment,AssessmentStates);
    const [InspectionState,InspectionDispatch] = useReducer(Inspections,InspectionStates);
    const [ChecklistManagerState,ChecklistManagerDispatch] = useReducer(ChecklistManager,ChecklistManagerStates);
    const [InvoiceState,InvoiceDispatch] = useReducer(Invoices,InvoiceStates);

    return <GlobalStore.Provider 
    value={{
        authState,
        AssessmentState,
        InspectionState,
        ChecklistManagerState,
        InvoiceState,
        authDispatch,
        AssessmentDispatch,
        InspectionDispatch,
        ChecklistManagerDispatch,
        InvoiceDispatch
    }} >
        {children}
    </GlobalStore.Provider>
}

export default StateStores;